<div class="leader-baord-section" id="leader-board-details">
    <div class="contest-leaderboard-head">
        <div class="header-main-div-top">
            <div class="row h-100 text-white ">
                <div class="col-12">
                    <div class="d-flex justify-content-between top-header-main">
                        <div class="mobile-back-btn" (click)="onClickViewLeaderBoard()">
                            <i class="pi pi-chevron-left"> </i> Back
                        </div>
                        <div class="mobile-back-btn d-flex share-button-div">
                            <!-- <i class="pi pi-share-alt " appPageScreenshot [fileName]="userContestLeaderBoardDetails?.userName+'_user-leaderboard_ScreenShot'"></i> -->
                            <div class="points-icon border border-2 rounded-circle p-1" (click)="showRulelist()">
                                <span class="fs-6">PTS</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="user-image-details">
                    <div class="user-details">
                        <div class="image-div">
                            <img src="{{userContestLeaderBoardDetails?.userImage}}" class="w-50 h-50 rounded-circle"
                            alt="Image not available">
                        </div>
                        <div class="details">
                            <h4 class="h4">{{ userContestLeaderBoardDetails?.userName }}</h4>
                            <h6 class="h6">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? userContestLeaderBoardDetails?.totalPoints+' Pts' : 'Yet to Start' }}</h6>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="palyer-data">
           <div class="main-palyer">
            <div class="palyer-image">
                <img src="{{userContestLeaderBoardDetails?.player1Image}}"
                class="image-div"
                alt="Image not available">
            </div>
            <div class="player-name">
                <p class="p-title-1">{{ userContestLeaderBoardDetails?.player1Name }}</p>
                <p class="p-title-2" style="color: grey;">{{ userContestLeaderBoardDetails?.tournamentName }}
                    ({{ userContestLeaderBoardDetails?.tournamentCategoryName }})</p>
            </div>
           </div>
            </div>
        </div>
      

        <div class="main-table-div">
            <div class="table">
                <table>
                    <thead>
                        <tr>
                            <th class="q-td">Contest Questions</th>
                            <th class="posint-td">Value</th>
                            <th class="into"></th>
                            <th class="values">Stats</th>
                            <th class="equal"></th>
                            <th class="tp-td">Points</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let questionAnswer of userContestLeaderBoardDetails?.questionAnswerData">
                            <td class="q-td">{{ questionAnswer?.question }}</td>
                            <td class="posint-td">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? questionAnswer?.points : '-'}}</td>
                            <td  class="into">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? 'x' : '' }}</td>
                            <td  class="values">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? questionAnswer?.playerPoints : '-'}}</td>
                            <td class="equal"> {{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? '=' : ''  }} </td>
                            <td  class="tp-td">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? questionAnswer?.actualPoints : '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="palyer-data two">
                <div class="main-palyer">
                 <div class="palyer-image">
                     <img src="{{userContestLeaderBoardDetails?.player2Image}}"
                     class="image-div"
                     alt="Image not available">
                 </div>
                 <div class="player-name">
                     <p class="p-title-1">{{ userContestLeaderBoardDetails?.player2Name }}</p>
                     <p class="p-title-2" style="color: grey;">{{ userContestLeaderBoardDetails?.tournamentName }}
                        ({{ userContestLeaderBoardDetails?.tournamentCategoryName }})</p>
                 </div>
                </div>
                 </div>
                 <div class="table">
                    <table>
                        <thead>
                            <tr>
                                <th class="q-td">Contest Questions</th>
                                <th class="posint-td">Value</th>
                                <th  class="into"></th>
                                <th  class="values">Stats</th>
                                <th class="equal"></th>
                                <th  class="tp-td">Points</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let questionAnswer of userContestLeaderBoardDetails?.questionAnswerDataTwo">
                                <td class="q-td">{{ questionAnswer?.question }}</td>
                                <td class="posint-td">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? questionAnswer?.points : '-'}}</td>
                                <td  class="into">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? 'x' : '' }}</td>
                                <td  class="values">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? questionAnswer?.playerPoints : '-'}}</td>
                                <td class="equal"> {{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? '=' : ''  }} </td>
                                <td  class="tp-td">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? questionAnswer?.actualPoints : '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                 </div>
                 <div class="total-pts-button">
                    <div class="total-points-badge">
                        <h3 class="text-dark h3 fw-bold">Total Points <span class="ml-0">{{ (eventStatictics?.tournamentMatchStatus !== 'notstarted') ? totalPoints : '-' }}</span></h3>
                    </div>
                 </div>
            
        </div>


        
 
    </div>
</div>


    <p-dialog id="terms" [closable]="true" [(visible)]="showRuleList" [modal]="true" [style]="{width: '500px'}"
    header="Points System"
   [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 60px)'}" [baseZIndex]="10000" [draggable]="false"
   [resizable]="false">
   <div class="modal-content team qize-section question-list quize-description">
    <div class="note-top">
        <p class="text">SELECT THE BEST COMBINATION TO MAXIMIZE YOUR POINTS</p>
    </div>
       <div class="modal-body modal-Detals">
           <div class="col-md-12 quiz-main-body">
               <div class="qizeheader ">
                   <div class="mobile-version">
                       <!-- <a onclick="history.back()" class="left-title mobile">
                           <i class='bx bx-left-arrow-alt'></i> Back
                       </a> -->
                   </div>
                   <div class="left-title   w-auto"> </div>
               </div>
               <div class="content">
                   <div class="container-fluid">
                       <div class="row">
                           <div class="col-sm-12 p-p-0">
                                <div class="point-list"> 
                                   <ul>
                                       <li>
                                           ⁠Choose 1 option from one player
                                       </li>
                                       <li>
                                        ⁠Choose 2 options for the other player
                                       </li>
                                    </ul>
                                    <div class="note2">
                                        <p class="text"> ⁠Total points will be calculated based on the 3 options selected</p>
                                    </div>
                                </div>
                                <div class="point-table">
                                   <table class="table table-striped">
                                       <thead>
                                           <tr>
                                               <th scope="col"  colspan="2">points system</th>
                                              
                                           </tr>
                                       </thead>
                                       <tbody>
                                           <tr>
                                               <th scope="row" class="entries-position">1 Point Won</th>
                                               <td class="table-data">1 point</td> 
                                           </tr>
                                           <tr>
                                               <th scope="row" class="entries-position">1 Game Won</th>
                                               <td class="table-data">6 points</td> 
                                           </tr>
                                           <tr>
                                               <th scope="row" class="entries-position">⁠1 Set Won</th>
                                               <td class="table-data">50 points</td> 
                                           </tr>
                                           <tr>
                                               <th scope="row" class="entries-position">1 Service  Point won</th>
                                               <td class="table-data">1.5 points</td> 
                                           </tr>
                                           <tr>
                                               <th scope="row" class="entries-position">⁠1 Ace</th>
                                               <td class="table-data">15 points</td> 
                                           </tr>
                                           <tr>
                                               <th scope="row" class="entries-position">1 Break Point won</th>
                                               <td class="table-data">20 points</td> 
                                           </tr>
                                          
                                       </tbody>
                                   </table>

                                </div>
                               
                               
                           </div> <!-- End of col-sm-12 -->
                       </div> <!-- End of row -->
                   </div> <!-- ENd of container fluid -->
               </div>
           </div>
       </div>
   </div>



</p-dialog>
